import {
  getNameDescriptionTableColumn,
  getProjectDomainTableColumn,
  getTimeTableColumn,
  getApplicationScopeTableColumn,
} from '@/utils/common/tableColumn'

export default {
  data () {
    return {
      columns: [
        getNameDescriptionTableColumn({
          onManager: this.onManager,
          hideField: true,
          formRules: [
            { required: true, message: this.$t('common.tips.input', [this.$t('table.title.name')]) },
          ],
          slotCallback: row => {
            return (
              <side-page-trigger onTrigger={() => this.handleOpenSidepage(row)}>{row.name}</side-page-trigger>
            )
          },
        }),
        {
          field: 'type',
          title: this.$t('report.template_type'),
          formatter: ({ row }) => {
            return this.$te(`report.template_type.${row.type}`) ? this.$t(`report.template_type.${row.type}`) : row.type || '-'
          },
        },
        getProjectDomainTableColumn({ vm: this }),
        getApplicationScopeTableColumn({
          vm: this,
          resource: 'report_templates',
          scope: 'domain',
        }),
        getTimeTableColumn(),
      ],
    }
  },
  methods: {
  },
}
